// src/components/Logout.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Clear the user session
        localStorage.removeItem('user');

        // Redirect to the login page
        navigate('/login');
    }, [navigate]);

    return (
        <div>
            Logging out...
        </div>
    );
};

export default Logout;
